import { ActuatorPortType, WorkingMode, ControlTypesToDisplayTextsMapping, ControlsType, } from '../types';
import { mapArrayToObject, mergeTimeSeriesData, isDefined } from '../utils';
import global from './global';
export const mergeOverrideActivityData = (systemOverrideDataset, localOverrideDataset, portType) => {
    const processedData = [];
    const isLocalOverrideForcedOn = portType === ActuatorPortType.NORMALLY_CLOSED;
    const isLocalOverrideForcedOff = portType === ActuatorPortType.NORMALLY_OPEN;
    // Merge TS data sets into a single array
    const preprocessedMergedDataset = mergeTimeSeriesData(systemOverrideDataset, localOverrideDataset);
    // Combine/Interpolate local and system datapoints into a single object
    // Then add object to the result array.
    preprocessedMergedDataset.forEach((d) => {
        //state refers to whether local override is active or not (not its actual state)
        //workingMode refers to system override mode (its actual state)
        const { timestamp, state, workingMode } = d;
        const isLocalOverrideActive = state || false;
        const overrideForcedOnValue = determineOverrideForceOnValue(isLocalOverrideActive, isLocalOverrideForcedOn, workingMode);
        const overrideForcedOffValue = determineOverrideForceOffValue(isLocalOverrideActive, isLocalOverrideForcedOff, workingMode);
        processedData.push({
            timestamp,
            isLocalOverrideActive,
            overrideForcedOnValue,
            overrideForcedOffValue,
            workingMode,
        });
    });
    return mapArrayToObject(processedData, 'timestamp');
};
export const determineOverrideForceOnValue = (isLocalOverrideActive, isLocalOverrideForceOn, systemOverrideWorkingMode) => {
    const isLocalOverrideStateForceOn = isLocalOverrideActive === true && isLocalOverrideForceOn;
    const isSystemOverrideStateForceOn = systemOverrideWorkingMode === WorkingMode.FORCE_ON;
    if (isLocalOverrideStateForceOn || isSystemOverrideStateForceOn)
        return 0.15;
    return null;
};
export const determineOverrideForceOffValue = (isLocalOverrideActive, isLocalOverrideForceOff, systemOverrideWorkingMode) => {
    const isLocalOverrideStateForceOff = isLocalOverrideActive === true && isLocalOverrideForceOff;
    const isSystemOverrideStateForceOff = systemOverrideWorkingMode === WorkingMode.FORCE_OFF;
    if (isLocalOverrideStateForceOff || isSystemOverrideStateForceOff)
        return 0.15;
    return null;
};
export const displayEquipmentActiveControlType = (activeControl) => {
    if (!isDefined(activeControl)) {
        return global.NOT_AVAILABLE;
    }
    switch (activeControl['_entity']) {
        case 'Scheduler':
            return ControlTypesToDisplayTextsMapping[ControlsType.SCHEDULER];
        case 'TemperatureControl': {
            const temperatureControl = activeControl;
            return ControlTypesToDisplayTextsMapping[temperatureControl.type];
        }
        case 'VenstarHVACControl':
        case 'HVACControl':
            return ControlTypesToDisplayTextsMapping[ControlsType.HVAC];
        default:
            return global.NOT_AVAILABLE;
    }
};
export const displaySchedulerDetails = (activeControl) => {
    const timetableId = activeControl === null || activeControl === void 0 ? void 0 : activeControl.timetableId;
    const lightSensor = activeControl === null || activeControl === void 0 ? void 0 : activeControl['lightSensorSettings'];
    const lightSensorExist = lightSensor ? Object.values(lightSensor).length > 0 : false;
    if ((activeControl === null || activeControl === void 0 ? void 0 : activeControl['_entity']) === 'Scheduler') {
        if (timetableId && lightSensorExist) {
            return '(TimeTable + LightSensor)';
        }
        else if (timetableId) {
            return '(TimeTable)';
        }
        else if (lightSensorExist) {
            return '(LightSensor)';
        }
        else {
            return global.NOT_AVAILABLE;
        }
    }
    else {
        return '';
    }
};
